import { render, staticRenderFns } from "./TournamentProductDealer.vue?vue&type=template&id=94d973c2"
import script from "./TournamentProductDealer.vue?vue&type=script&lang=js"
export * from "./TournamentProductDealer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports